module.exports = __webpack_public_path__ + "static/media/anne-hathaway-lose.461f7deb.jpg";